module.exports = __webpack_public_path__ + "static/media/loader-2.0840cf40.gif";